export const formatDate = (dateString) => {
    if (dateString) {
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();
        return `${day}.${month}.${year}`;
    } else {
        return <span style={{color: 'rgb(169, 169, 169)'}}>Отсутствует</span>;
    }
};
export const formatDateTime = (isoDate) => {
    // Убираем символы после секунды, если они есть
    if (!isoDate) return 'Некорректная дата';
    const cleanDate = isoDate.replace(/\.\d+Z$/, '');

    const date = new Date(cleanDate);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
};
export const formatComment = (comment) => {
    if (!comment) {
        return <span style={{color: 'rgb(169, 169, 169)'}}>Комментарий отсутствует</span>
    } else {
        return <span>{comment}</span>;
    }
};
export const formatOverflow = (data) => {
    if (data.length > 50) {
        return data.slice(0, 50) + '...';
    }
    return data;
};
export const formatNull = (data) => {
    if (data === '' || data === undefined || data === null) {
        return <span style={{color: 'rgb(169, 169, 169)'}}>Отсутствует</span>
    }else {
        return <span>{data}</span>;
    }
};

// Функция покраски строки дела в красный, если оно просрочено
export const getCaseStyle = (dateEnd, dateCourt, dateAMAppointment, status) => {
    const todayMSC = new Date();
    todayMSC.setHours(todayMSC.getHours() + 3); // Перевод времени в МСК

    const isPastCourtDate = dateCourt && new Date(dateCourt) < todayMSC && !dateAMAppointment && status !== 'Завершено';

    if (isPastCourtDate) {
        return { border: '1px solid rgb(56, 0, 0)', backgroundColor: 'rgb(255, 240, 240)' }; // Бордовый стиль
    }

    if (!dateEnd) {
        return { border: '1px solid blue', backgroundColor: 'rgb(235, 245, 255)' }; // Синий стиль
    }

    const isPastEndDate =
        new Date(dateEnd) < todayMSC && status !== 'Завершено';

    if (isPastEndDate) {
        return { border: '1px solid rgb(255, 14, 14)', backgroundColor: 'rgb(255, 247, 247)' }; // Красный стиль
    }

    return {}; // Если нет условий, оставить стиль по умолчанию
};

export const isWithinLastHalfHour = (creationTime) => {
    const now = new Date();
    now.setHours(now.getHours() + 3); // Перевод в МСК
    const creationDate = new Date(creationTime);
    const diffInMinutes = (now - creationDate) / (1000 * 60);
    return diffInMinutes <= 30;
};